import { createFileRoute } from '@tanstack/react-router';
import { S5bSessions } from '@/screens/S5bSessions/S5bSessions';

export const Route = createFileRoute('/$orgId/analyze/sessions')({
  component: () => <S5bSessions />,
});
